import script from "./riskSuitability.vue?vue&type=script&setup=true&lang=js"
export * from "./riskSuitability.vue?vue&type=script&setup=true&lang=js"

import "./riskSuitability.vue?vue&type=style&index=0&id=175583df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-175583df"]])

export default __exports__